import './Month.css';
export default {
    "month": "Month_month__1hq0t",
    "monthDates": "Month_monthDates__1hq0t"
};
